(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["hero"] && !Shopify.designMode) return;
  try {
    
  // Hero videos carry preload="none" and no autoplay attribute, so nothing is fetched until this
  // observer starts one. A display:none variant never intersects, so each device downloads only
  // the desktop or mobile video it actually shows.
  (() => {
    const SELECTOR = 'video[data-autoplay-on-visible]';

    if (!('IntersectionObserver' in window)) return;

    const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

    const observer = new IntersectionObserver(
      (entries) => {
        for (const entry of entries) {
          const video = /** @type {HTMLVideoElement} */ (entry.target);

          if (!entry.isIntersecting) {
            if (!video.paused) video.pause();
            continue;
          }

          if (reduceMotion.matches) continue;
          // Rejected by iOS in Low Power Mode; the poster stays visible, which is the point.
          video.play()?.catch(() => {});
        }
      },
      // Start slightly before the hero scrolls in so playback is underway on arrival.
      { rootMargin: '200px 0px', threshold: 0.01 },
    );

    // Elements currently registered with `observer` — tracked so a detached one (removed by a
    // section reload) can be unobserved individually. `observer.observe()` on an
    // already-observed target is a no-op, so this set also keeps `observe()` idempotent.
    const observedVideos = new Set();

    const observe = (root) => {
      for (const video of (root ?? document).querySelectorAll(SELECTOR)) {
        if (observedVideos.has(video)) continue;
        observer.observe(video);
        observedVideos.add(video);
      }
    };

    observe();
    // Theme editor re-renders sections without a page load, and soft-nav swaps replace section
    // content via innerHTML — either way, by the time this fires the old <video> elements are
    // already detached but still referenced (and un-GC-able) by `observer` unless explicitly
    // unobserved. Prune those before observing whatever's new in the reloaded section.
    document.addEventListener('shopify:section:load', (event) => {
      for (const video of observedVideos) {
        if (video.isConnected) continue;
        observer.unobserve(video);
        observedVideos.delete(video);
      }
      observe(event.target);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true },
    );
  }

  } catch(e) { console.error(e); }
})();
})();
